/** Touch reorder arithmetic (spec 11.5), pure for unit tests. */
/** The new index for a card whose centre is at `centre`, among the others' centres. */
export function reorderTarget(mids: number[], from: number, centre: number): number {
  let over = 0;
  mids.forEach((m, j) => { if (j !== from && m < centre) over++; });
  return over;
}

/** The list with the item at `from` moved to `to`. */
export function moveItem<T>(items: T[], from: number, to: number): T[] {
  const next = items.slice();
  const [moved] = next.splice(from, 1);
  next.splice(to, 0, moved);
  return next;
}
